(()=>{
 if(window.aqjPriceHoldToken)return;
 const cartKey='aquora_animal_jewelry_cart_v1',holdKey='aquora_animal_jewelry_price_hold_v1';
 const roots=[...document.querySelectorAll('[data-aqj-price-hold]')];
 let current=null,pending='',generation=0,retryAt=0,lastAttempt='';
 const fingerprint=lines=>JSON.stringify(lines.map(x=>[String(x.id),Number(x.quantity),0]).sort((a,b)=>String(a[0]).localeCompare(String(b[0]))));
 function lines(){try{const a=JSON.parse(localStorage.getItem(cartKey)||'[]');return Array.isArray(a)?a.filter(x=>x&&/^\d+$/.test(String(x.id))&&Number.isInteger(x.quantity)&&x.quantity>0):[]}catch{return[]}}
 const hide=()=>roots.forEach(x=>x.hidden=true);
 function remaining(){return current?Math.max(0,current.expira-Date.now()-current.offset):0}
 function paint(){const left=remaining();if(!left){hide();return false}const sec=Math.min(600,Math.ceil(left/1000));for(const root of roots){root.querySelector('[data-aqj-hold-min]').textContent=String(Math.floor(sec/60)).padStart(2,'0');root.querySelector('[data-aqj-hold-sec]').textContent=String(sec%60).padStart(2,'0');root.hidden=false}return true}
 function savedFor(fp){try{const s=JSON.parse(localStorage.getItem(holdKey)||'null');return s?.carrito===fp?s:null}catch{return null}}
 function usable(s,fp){
  if(!s||s.carrito!==fp||typeof s.token!=='string'||!s.token.includes('.')||!Number.isFinite(s.expira)||!Number.isFinite(s.offset))return false;
  const left=s.expira-Date.now()-s.offset;
  return left>0&&left<=600001;
 }
 function forgetSaved(){try{localStorage.removeItem(holdKey)}catch{}}
 window.aqjPriceHoldToken=items=>current&&current.carrito===fingerprint(items)&&remaining()>0?current.token:null;
 async function refresh(){
  const items=lines(),fp=fingerprint(items);
  if(!items.length){++generation;pending='';current=null;retryAt=0;hide();forgetSaved();return}
  if(current?.carrito===fp&&paint()&&(!retryAt||Date.now()<retryAt))return;
  const saved=savedFor(fp);
  // A quote already accepted from the server remains valid until its original expiry.
  // Restore it immediately; revalidate in the background without hiding it on reload.
  if(!usable(current,fp))current=usable(saved,fp)?saved:null;
  if(current)paint();else hide();
  if(fp===pending||Date.now()<retryAt&&fp===lastAttempt)return;
  const version=++generation;pending=fp;lastAttempt=fp;
  const started=Date.now(),controller=new AbortController();
  const timeout=setTimeout(()=>controller.abort(),8000);
  try{
   const response=await fetch('https://checkout.aquoratry.com/api/reserva-joyeria',{method:'POST',credentials:'omit',cache:'no-store',signal:controller.signal,headers:{'content-type':'application/json'},body:JSON.stringify({c:items.map(x=>({v:String(x.id),q:x.quantity,s:0})),...(saved?.token?{reserva:saved.token}:{})})});
   if(!response.ok)throw Error('hold_unavailable');
   const data=await response.json(),hold=data.reserva,now=Date.now();
   if(version!==generation||fp!==fingerprint(lines()))return;
   if(data.moneda!=='USD'||!(data.total>0)||typeof hold?.token!=='string'||!Number.isFinite(hold.expira)||!Number.isFinite(data.ahora)||hold.expira<=data.ahora||hold.expira-data.ahora>600001)throw Error('invalid_hold');
   current={carrito:fp,token:hold.token,expira:hold.expira,offset:data.ahora-(started+now)/2};
   // Storage failure must not turn a successful quote into a hidden timer.
   try{localStorage.setItem(holdKey,JSON.stringify(current))}catch{}
   retryAt=0;paint();
  }catch{
   if(version===generation){
    retryAt=Date.now()+30000;
    if(usable(current,fp))paint();else{current=null;hide()}
   }
  }finally{clearTimeout(timeout);if(version===generation)pending=''}
 }
 window.addEventListener('aqj:cart-updated',refresh);
 window.addEventListener('storage',event=>{if(event.key===cartKey)refresh()});
 window.addEventListener('pageshow',refresh);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh()});
 setInterval(()=>{if(!current||current.carrito!==fingerprint(lines())||!paint()||retryAt&&Date.now()>=retryAt)refresh()},1000);
 refresh();
})();
